import React from 'react';
// Marka işaretinin TEK kaynağı @cafeoto/ui/brand — vitrin kendi kopyasını
// tutarsa fiyat listesiyle aynı şey olur: işaret güncellenir, vitrin eskide
// kalır ve hiçbir yerde hata çıkmaz.
import markUrl from '@cafeoto/ui/brand/logo.svg';
import iconUrl from '@cafeoto/ui/brand/icon-app.svg';

// mark: açık zeminde yalın işaret. icon: kırmızı dolgulu kare — köşeyi ÇAĞIRAN
// yuvarlıyor (className), dosyaya yuvarlak köşe çizmek iOS/Android simgesinde
// köşelerde beyaz üçgen bırakıyor.
const SOURCES = { mark: markUrl, icon: iconUrl };

const Logo = ({ size = 40, variant = 'mark', className = '' }) => {
  return (
    <img
      src={SOURCES[variant] || SOURCES.mark}
      alt="Cafe Otomasyonu"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      style={{ width: size, height: size }}
    />
  );
};

export default Logo;
